import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { upcomingSessionsSelector } from '../../../../../selectors/SessionSelectors';
import { fetchUpcomingSessions } from '../../../../../actions/SessionActions';
import { MoveToNextSessionBanner, NEXT_SESSION_TIME_RANGE } from './MoveToNextSessionBanner';

const mapStateToProps = (state) => ({
    upcomingSessions: upcomingSessionsSelector(state, NEXT_SESSION_TIME_RANGE)
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        fetchUpcomingSessions,
    }, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(MoveToNextSessionBanner);
